// extracted by mini-css-extract-plugin
module.exports = {"returnTruckWrapper":"rejected-truck-circle_returnTruckWrapper__3Kvwl","returnAnimation":"rejected-truck-circle_returnAnimation__1VhR_"};